import React from "react";
import { toast } from "react-toastify";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    toast.error(`Bir hata oluştu: ${error.message}`);
    console.log(error.message)
    console.error("ErrorBoundary yakaladı:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return null; // Boş dönebilir veya fallback UI
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
